import { TYPES } from "@actions/referral-rewards-actions";
import INITIAL_STATE from "./initial-state";

const referralRewards = (state = INITIAL_STATE.referralRewards, action) => {
  switch (action.type) {
    case TYPES.SET_REFERRAL_REWARDS:
      return action.referralRewards;
    default:
      return state;
  }
};

export default referralRewards;
